<template>
  <div>
    <div v-if="Object.keys(data).length > 0">
      <b-row>
        <b-col cols="12">
          <contract-info
            :data="data"
            @reload="reload"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <contract-equipment
            v-if="idcontrato"
            :idcontrato="idcontrato"
            :data="data"
          />
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <div v-if="!working">
        <b-alert
          variant="danger"
          show
          class="mb-0"
        >
          <div class="alert-body">
            <feather-icon
              icon="InfoIcon"
              class="mr-50"
            />
            No existen registros para mostrar &nbsp;
            <strong><b-link
              :to="{ name: 'home' }"
            >Volver</b-link></strong>
          </div>
        </b-alert>
      </div>
      <div v-else>
        <b-alert
          variant="secondary"
          show
          class="mb-0"
        >
          <div class="alert-body">
            <feather-icon
              icon="SearchIcon"
              class="mr-50"
            />
            <b-spinner small />
            <span>Procesando, Espere por favor..!</span>
          </div>
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import router from "@/router"
import { BAlert, BCol, BLink, BRow, BSpinner } from "bootstrap-vue"
import ContractEquipment from "./ContractEquipment.vue"
import ContractInfo from "./ContractInfo.vue"

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,
    BSpinner,
    ContractInfo,
    ContractEquipment,
  },
  data() {
    return {
      // eslint-disable-next-line radix
      id: parseInt(router.currentRoute.params.id),
      userData: JSON.parse(localStorage.getItem("userData")),
      idcontrato: null,
      data: {
        codigo: "",
        apenom: "",
      },
      working: false,
    }
  },
  created() {
    if (!Number.isNaN(this.id)) {
      this.searchContract()
    }
  },
  methods: {
    searchContract() {
      this.working = true
      this.$http
        .get("/contrato", {
          params: {
            idcontrato: this.id,
            idusuario: this.userData.id,
          },
        })
        .then((response) => {
          this.working = false
          if (response.data.data.length > 0) {
            this.data = response.data.data[0] || {}
            this.idcontrato = response.data.data[0].idcontrato
            this.setTitle()
          }
        })
        .catch((error) => {
          this.working = false
          console.log(error)
        })
    },
    reload() {
      this.$router.go(0)
    },
    setTitle() {
      document.title = `${this.data.codigo} - ${this.data.apenom}`
    },
  },
}
</script>
